<div class="plan-list__container">
    {#await plans}
        <LoadingState />
    {:then plans}
        {#if plans && plans.length > 0}
            <List>
                <thead slot="header">
                    <ListElement header>
                        <Cell header />
                        <Cell header>
                            <span slot="header">{i18n.plansHeader}</span>
                        </Cell>
                    </ListElement>
                </thead>
                <tbody slot="body">
                    {#each plans as plan}
                        <ListElement
                            on:click={() => {
                                onItemSelected(plan);
                            }}
                        >
                            <Cell type="plan-icon">
                                <span
                                    class="plan-label"
                                    style={getPlanIconImageStyle(plan)}
                                    slot="data"
                                ></span>
                            </Cell>
                            <Cell type="plan-info">
                                <div slot="data">
                                    <span>{plan.title ? plan.title : i18n.noTitle}</span>
                                    <IconButton
                                        htmlType="button"
                                        iconOnly={true}
                                        iconClass="explore-button"
                                        type="plain"
                                        ariaLabel="{getPlanButtonText(plan)}"
                                        text="{getPlanButtonText(plan)}"
                                    />
                                </div>
                            </Cell>
                        </ListElement>
                    {/each}
                </tbody>
            </List>
        {:else}
            <EmptyState iconName="plans" title={i18n.noPlans} showButton={false} />
        {/if}
    {:catch error}
        <p>{error.message}</p>
    {/await}
</div>

<script>
    import { createEventDispatcher } from "svelte";

    import List from "@itslearning/prometheus/assets/lists/List/v1/List.svelte";
    import ListElement from "@itslearning/prometheus/assets/lists/ListElement/v1/ListElement.svelte";
    import Cell from "@itslearning/prometheus/assets/lists/Cell/v1/Cell.svelte";
    import IconButton from '@itslearning/prometheus/assets/inputs/IconButton/v1/IconButton.svelte';
    import EmptyState from "@itslearning/prometheus/assets/nodes/EmptyState/v1/EmptyState.svelte";

    import LoadingState from "@its-ui/common-components/LoadingState/LoadingState.svelte";

    import { formatLanguageString } from "@itslearning/atlas/strings/format.js";

    export let i18n;
    export let plans;

    const dispatch = createEventDispatcher();

    const getPlanIconImageStyle = plan =>
        plan.hasImage ? `background-image: url('${plan.imageUrl}'); background-size: cover;` : "";

    function onItemSelected(item) {
        dispatch("itemSelected", item);
    }

    function getPlanButtonText(plan) {
        return formatLanguageString(i18n.planner2_TableView_Topics_Select_X, plan.title ? plan.title : i18n.noTitle);
    }
</script>
